import React, { useState, useEffect } from 'react';
import axios from "axios";
import MoreUpdate from "./MoreUpdate";
import FrontpageSelection from "./FrontpageSelection";
import Testimonial3 from "./Testimonial3";
import ShowCollection from "./ShowCollection";
import FeaturedWorkshops from "./FeaturedWorkshops";
import FrontpageInfo from "./FrontpageInfo";

function HomeFour() {

  // API configuration constants
  const API_URL = `${process.env.REACT_APP_API_FOLDER}list_collections/`;
  const API_TOKEN = process.env.REACT_APP_API_TOKEN;


  // State management for data, loading status, and error handling
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    /**
     * Fetches data from the API with authentication token
     */
  
    const fetchData = async () => {
      try {
        const response = await axios.get(API_URL, {
          headers: { "X-API-TOKEN": API_TOKEN }
        });
        
        const data = response.data; // Use the response data directly
        setCollections(data);

        setLoading(false);
      } catch (error) {
        console.error("API Error:", error);
        setError(error.message || "Failed to fetch API");
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array means this effect runs once on mount

  console.log(error);



    // Map over the fetched workshops to render slides
    const collectionAreas = collections && collections.length > 0 
      ? collections.map((clctn, index) => {
        return (
        <ShowCollection key={index} cid={clctn} />
        );
      })
      : null;





  return (
    <>
      <FeaturedWorkshops />
      <FrontpageInfo />
      <FrontpageSelection />

      {collectionAreas}

      <Testimonial3 />
      <MoreUpdate />
    </>
  );
}

export default HomeFour;
